import styled from 'styled-components';
import colors from '../../theme/search/colors';

const Wrapper = styled.div`
  .filter-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 17px;
    padding-right: 17px;
    background-color: ${colors.grayFour};
    border: 1px solid ${colors.lightGrey};
    border-left: 0;
    border-bottom: 0;
    border-right: 0;
    height: 42px;
    cursor: pointer;

    & .filter-title {
      font-size: 15px;
      line-height: 18px;
      color: ${colors.darkGray};
      text-transform: uppercase;
    }

    & .filter-icon {
      -webkit-transition: -webkit-transform 0.3s ease-in-out;
      -ms-transition: -ms-transform 0.3s ease-in-out;
      transition: transform 0.3s ease-in-out;

      path {
        stroke: ${colors.borderSelect};
      }
    }
  }

  .filter-content {
    height: 100%;
    overflow: visible;
    transition: max-height 0.3s ease-in-out;
    padding-top: 21px;
    padding-bottom: 21px;
  }

  .filter-content-container {
    height: 100%;
    overflow: hidden;
    padding: 20px;
    transition: max-height 0.3s ease-in-out;
  }
`;

const svgStyle = {
  width: 32
};

export { Wrapper, svgStyle };



// WEBPACK FOOTER //
// ./src/components/DateFilter/style.js